<template>
    <div class="py-3">
        <div class="container">
            <!-- trip profile navbar !-->
            <div class="row">
                <div class="col-md-12">
                    <h4 style="font-weight:900;">Misc Expense Report <span v-if="!loading && expenseReportID" class="fa fa-print" @click="openPrintView()" title="Print View"></span> <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner></h4>
                    <div v-if="!loading">{{expenseReportStatus.expenseReportStatusTypeName}}</div>
                    <b-input v-if="!loading" class="my-1 w-25" v-model="expenseReport.reportName" placeholder="Report Name"></b-input>
                    <div v-if="!loading">
                        <table class="table b-table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <!--<th scope="col">Amount</th>
                                <th scope="col">Projects</th>-->
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="i,iIndex in expenseReport.miscReportItems">
                                    <td style="max-width: 250px;">
                                        <div>
                                            <button @click="showRemovalModal(ItemRemoveType.MiscReport,iIndex,null)" class="btn btn-primary btn-sm" style="margin-top: .75rem;">X</button>
                                        </div>
                                    </td>
                                    <td style="min-width:225px;">
                                        <datepicker placeholder="Purchase Date" :typeable="false" :format="'MMMM dd yyyy'" input-class="form-control my-1" :use-utc=false v-model="i.itemDate"></datepicker>
                                        <textarea rows="2" @focus="$event.target.select()" class="form-control  my-3" placeholder="Vendor" v-model="i.vendor "></textarea>
                                    </td>
                                    <td style="min-width:225px;">
                                        <b-form-group>
                                            <b-form-select class="my-1" v-model="i.miscReportItemTypeId" :options="reportItemTypes" value-field="id" text-field="displayName">
                                                <option :value="null" disabled>Description</option>
                                            </b-form-select>
                                        </b-form-group>

                                        <b-form-textarea v-if="i.miscReportItemTypeId == 7"
                                                         id="InsuranceExceedsPolicyLimitsComment"
                                                         v-model="i.miscReportItemTypeComment"
                                                         placeholder="Describe"
                                                         rows="1"
                                                         max-rows="3"
                                                         style="margin-bottom:15px;">
                                        </b-form-textarea>
                                        <textarea rows="2" @focus="$event.target.select()" class="form-control my-1" placeholder="Reason" v-model="i.reason "></textarea>
                                    </td>
                                    <td style="min-width:150px;">
                                        <div v-for="(p,pAIndex) in i.projectAmountAllocations">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <button @click="showRemovalModal(ItemRemoveType.ProjectAllocation,iIndex,pAIndex)" class="btn btn-primary btn-sm my-1" style="margin-top: .75rem;">X</button>
                                                </div>
                                                <input type="number" @focus="$event.target.select()" class="form-control my-1" placeholder="Amount" v-model="p.allocationValue">
                                            </div>

                                        </div>
                                        <button @click="onAddprojectAmountAllocation(i)" v-b-tooltip.hover title="allocate expenses to another project" class="btn btn-primary btn-sm my-1">Split Costs</button>
                                        <div>Sub-total: {{subTotalMiscReportItemAmount(i) | currency}}</div>

                                    </td>
                                    <td style="min-width:250px;">
                                        <div class="my-1" v-for="(p,pAIndex) in i.projectAmountAllocations">
                                            <b-form-select class="" style="margin-bottom:.375rem;" :id="pAIndex" :options="projects" text-field="projectName" value-field="id" v-model="p.projectId">
                                                <option :value="null" disabled>Choose a project</option>
                                            </b-form-select>
                                            <router-link :to="{ name: 'project-users-edit', query: { 'returnExpenseReportID': expenseReportID, 'isMiscReport': true } }">Assign new project</router-link>
                                        </div>
                                        <div class="" style="">
                                            <button class="btn btn-primary btn-sm" @click="$bvModal.show('miscReportItemAttachmentsModal'+ iIndex)">Attach Receipt</button>
                                            <b-modal :id="'miscReportItemAttachmentsModal' + iIndex" centered title="Add Receipt" :hide-footer=true>
                                                <AttachmentComponent :expenseReportId="expenseReportID" :attachments="i.attachments" @fileUploadDone="$bvModal.hide('miscReportItemAttachmentsModal'+ iIndex)"></AttachmentComponent>
                                            </b-modal>
                                            <span style="cursor: pointer">
                                                <div v-for="(baa, baaIndex) in i.attachments">
                                                    <span @click="downloadFileInNewWindow(baa)">{{baa.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.MiscReportAttachment,iIndex,baaIndex)">&times;</span>
                                                </div>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12" v-if="!loading">
                    <div class="alert alert-warning" v-if="expenseReport && expenseReport.hasItemDateOutsideOneOrMoreProjectDates">
                        <i class="fa fa-exclamation-triangle mr-1"></i>
                        <em>Warning</em> - some of the costs fall outside of one or more of the allocated project's Period of Performance.
                        <span v-if="expenseReportStatusTypeId == 1 || expenseReportStatusTypeId == 5 || expenseReportStatusTypeId == 6">Are you sure you want to submit?</span>
                    </div>
                </div>
                <div v-if="!loading" class="col-12 mb-1 align-self-start margin-bottom">
                    <button @click="onAdd" class="btn btn-primary btn-lg">Add New Expense</button>
                </div>
                <div class="col-12" v-if="!loading">
                    <b-form-textarea id="supportingRemark"
                                     v-model="expenseReport.supportingRemark"
                                     placeholder="Supporting remarks, if needed"
                                     rows="1"
                                     max-rows="3"
                                     style="margin-bottom:15px;">
                    </b-form-textarea>
                </div>
                <div v-if="!loading" class="col-12">

                    <div class="pull-right">
                        <span style="font-weight:700; font-size:16px; margin-right:15px;">Total: {{totalMiscReportItemAmount | currency}}</span>
                        <button @click="onSave" style="margin-right:10px;" class="btn btn-primary btn-lg">Save</button>
                        <button v-if="expenseReportStatusTypeId == 1 || expenseReportStatusTypeId == 5 || expenseReportStatusTypeId == 6" @click="onSubmit(false)" class="btn btn-primary btn-lg" style="margin-right:10px;">Submit</button>
                        <button v-if="expenseReportStatusTypeId == 2" @click="onApproval" class="btn btn-primary btn-lg" style="margin-right:10px;">PI Approve</button>
                        <button v-if="expenseReportStatusTypeId == 3 && isAdmin" @click="onApproval" class="btn btn-primary btn-lg" style="margin-right:10px;">Admin 1 Approve</button>
                        <button v-if="expenseReportStatusTypeId == 4 && isAdmin" @click="onApproval" class="btn btn-primary btn-lg" style="margin-right:10px;">Admin 2 Approve</button>
                        <button v-if="expenseReportStatusTypeId == 2" @click="onDeny" class="btn btn-primary btn-lg">Send back to user</button>
                        <button v-if="expenseReportStatusTypeId == 3 && isAdmin || expenseReportStatusTypeId == 4 && isAdmin" @click="onDeny" class="btn btn-primary btn-lg">Send back to user</button>
                    </div>
                </div>
                <CommentsComponent v-if="!loading && expenseReportStatusTypeId > 1" :expenseReportID="expenseReportID" :area="'misc'"></CommentsComponent>
                <div class="col-md-12" v-if="!loading && expenseReportStatusTypeId > 1">
                    <AuditHistoryComponent :expenseReportID="expenseReportID" :area="'misc'"></AuditHistoryComponent>
                </div>

            </div>
        </div>
        <modal title="Confirm Delete?" :is-small="true" v-if="show_modal_remove" @close="show_modal = false">
            <div class="modal-body">
                Are you sure you want to remove this item?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="removeItem(itemTypeToRemove, itemToRemove, attachmentToRemove)">Delete</button>
                <button type="button" class="btn btn-primary" @click="show_modal_remove = false">Cancel</button>
            </div>
        </modal>
        <modal title="Successfully submitted" :is-small="true" v-if="show_modal" @close="show_modal = false">
            <div class="modal-body">
                Your expense report has been successfully submitted. Click ok to continue.
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="$router.push('/')">Ok</button>
            </div>
        </modal>
        <modal title="Save progress?" :is-small="true" v-if="show_save_modal" @close="show_save_modal = false">
            <div class="modal-body">
                Save changes to expense report?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="onSave()">Save</button>
                <button type="button" class="btn btn-primary" @click="show_save_modal=false">Cancel</button>
            </div>
        </modal>
        <b-modal id="confirm-submit-modal" centered title="Warning" :hide-footer="true">
            Some of the costs fall outside of one or more of the allocated project's Period of Performance. Are you sure you want to submit?
            <div class="d-flex align-items-center justify-content-end mt-2">
                <button type="button" class="btn btn-secondary" @click="hideConfirmModal()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary ml-1" @click="onSubmit(true)">
                    Submit
                </button>
            </div>
        </b-modal>
    </div>
</template>

<style scoped>
    .btn-text-white {
        color: white !important
    }
    .margin-bottom {
        margin-bottom: 20px !important
    }
</style>

<script>
    // @ is an alias to /src
    import Datepicker from 'vuejs-datepicker';
    import modal from '@/components/modal.vue'
    import MiscExpenseReportService from '@/services/MiscExpenseReportService'
    import SubmissionService from '@/services/SubmissionService'
    import ApprovalService from '@/services/ApprovalService'
    import TripProfileService from '@/services/TripProfileService'
    import AttachmentComponent from '@/components/AttachmentComponent.vue'
    import CommentsComponent from '@/components/CommentsComponent.vue'
    import UserService from '@/services/UserService';
    import { msalMixin } from 'vue-msal';        
    import AuditHistoryComponent from '@/components/AuditHistoryComponent.vue'
    import ProjectService from '@/services/ProjectService'

    export default {
        name: 'misc-expense-report',
        components: {
            Datepicker,
            modal,
            AttachmentComponent,
            CommentsComponent,
            AuditHistoryComponent
        },
        async created() {
            //check if existing report
            if (this.$route.params.erid) {
                this.loading = true;
                this.expenseReportID = this.$route.params.erid;
                this.expenseReport = await MiscExpenseReportService.get(this.expenseReportID);
                this.expenseReportStatus = await TripProfileService.getExpenseReportStatus(this.expenseReportID);
                this.expenseReportStatusTypeId = this.expenseReportStatus.expenseReportStatusTypeId;
                try {
                    if (this.expenseReportStatusTypeId != 1) {
                        this.submission = await SubmissionService.getExpenseReportSubmission(this.expenseReportID);
                    }
                    
                } catch (e) {
                }
            }
            //its new, seed a desitnation object
            else {
                //create base expense report object
                this.expenseReport = { ...this.expenseReportModel }
                this.expenseReport.miscReportItems.push({
                    amount: null,
                    attachments: [
                    ],
                    itemDate: "",
                    miscReportItemTypeComment: "",
                    reason: "",
                    vendor: "",
                    miscReportItemTypeId: null,
                    projectAmountAllocations: [
                        {
                            projectId: null,
                            allocationValue: null
                        }
                    ]
                })
            }
            this.reportItemTypes = await MiscExpenseReportService.getItemTypes();
            this.projects = this.getProjects();
            this.loading = false;
            this.hash = this.hashData;
        },
        mixins: [msalMixin],
        data: function () {
            return {
                //test see if that is right.
                expenseReportStatus: {
                    expenseReportStatusTypeName: ""
                },
                show_modal: false,
                expenseReportStatusTypeId: 0,
                loading: false,
                disableLinks: true,
                expenseReportID: null,
                expenseReport: null,
                reportItemTypes: [],
                projects: [],
                submitModel: {
                    expenseReportId: null,
                    supportingRemark: "",
                    isPercentAmountAllocation: false,
                    hasForfeitedExpenditureCancellation: true,
                    forfeitedExpenditureCancellationComment: "",
                    hasMinimizeCosts: true,
                    hasMinimizeCostsComment: "",
                },
                expenseReportModel: {
                    expenseReportId: null,
                    reportName: null,
                    miscReportItems: [],
                    supportingRemark: ""
                },
                isAdmin: false,
                submission: null,
                show_modal_remove: false,
                show_save_modal: false,
                itemToRemove: null,
                attachmentToRemove: null,
                itemTypeToRemove: null,
                ItemRemoveType: {
                    ProjectAllocation: 0,
                    MiscReportAttachment: 1,
                    MiscReport: 2
                },
                hash: null
            }
        },
        watch: {
            'msal.accessToken': {
                async handler(value) {
                    console.log('getting user roles')
                    this.isAdmin = await UserService.isUserAdmin();
                },
                immediate: true
            }
        },
        computed: {
            totalMiscReportItemAmount() {
                let total = 0;
                if (this.expenseReport != null && this.expenseReport.miscReportItems != null && this.expenseReport.miscReportItems.length > 0) {
                    this.expenseReport.miscReportItems.forEach(function (item) { total = Number(total) + Number(item.amount) })
                }
                return total;
            },
            hashData: function () {
                return JSON.stringify(this.expenseReport);
            }    
            //miscReportStatus() {
            //    let status = ''
            //    switch (expression) {
            //        case 1:
            //            // code block
            //            break;
            //        case 2:
            //            status =
            //            break;
            //        default:
            //            status = 'New'
            //    }

            //    return status;
            //}
        },      
        methods: {
            removeItem(itemType, index, attachIndex) {
                switch (itemType) {
                    case 0:
                        this.onDeleteItemProjectAllocation(index, attachIndex);
                        break;
                    case 1:
                        this.removeMiscReportAttachment(index, attachIndex);
                        break;
                    case 2:
                        this.onDeleteItem(index);
                        break;
                    default:
                        break;
                }
                this.show_modal_remove = false;
            },
            showRemovalModal(itemType, index, attachIndex) {
                this.itemToRemove = index;
                this.itemTypeToRemove = itemType;
                this.attachmentToRemove = attachIndex;
                this.show_modal_remove = true;
            },
            async onApproval() {
                try {
                    this.loading = true;
                    await ApprovalService.submitApproval(this.expenseReportID);
                    const redirect = await ApprovalService.getRedirectURL(this.expenseReportStatusTypeId);
                    this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Approval request sent successfully." });
                    this.expenseReportStatus = await TripProfileService.getExpenseReportStatus(this.expenseReportID);
                    this.expenseReportStatusTypeId = this.expenseReportStatus.expenseReportStatusTypeId;
                    if (redirect)
                        this.$router.push(redirect)
                } catch (e) {
                    this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                } finally {
                    this.loading = false;
                }
            },
            async onDeny() {
                try {
                    this.loading = true;
                    await ApprovalService.deny(this.expenseReportID);
                    this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Sent back to user successfully." });
                    this.expenseReportStatus = await TripProfileService.getExpenseReportStatus(this.expenseReportID);
                    this.expenseReportStatusTypeId = this.expenseReportStatus.expenseReportStatusTypeId;
                } catch (e) {
                    this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                } finally {
                    this.loading = false;
                }
            },
            subTotalMiscReportItemAmount(item) {
                let total = 0;
                if (item != null && item.projectAmountAllocations != null && item.projectAmountAllocations.length > 0) {
                    item.projectAmountAllocations.forEach(function (paaItem) {
                        total = Number(total) + Number(paaItem.allocationValue)
                    })
                }
                item.amount = total;
                return total;
            },
            removeMiscReportAttachment(itemIndex, attachmentIndex) {
                this.expenseReport.miscReportItems[itemIndex].attachments.splice(attachmentIndex, 1);
            },
            downloadFileInNewWindow(params) {
                console.log(params)
                let documentType = 'receipts/';
                if (params.attachmentTypeId == 2) {
                    documentType = 'InstitutionalDocuments/'
                }
                this.$http
                    .get(documentType + params.attachmentId + '/Download', {
                        responseType: 'blob',
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        const file = new Blob(
                            [response.data],
                            { type: response.headers['content-type'] });
                        const downloadUrl = window.URL.createObjectURL(file);
                        window.open(downloadUrl);
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            onDeleteItem(indexOfItem) {
                this.expenseReport.miscReportItems.splice(indexOfItem, 1)
            },
            onDeleteItemProjectAllocation(indexOfItem, indexOfProjectAllocation) {
                this.expenseReport.miscReportItems[indexOfItem].projectAmountAllocations.splice(indexOfProjectAllocation, 1)
            },
            onAdd() {
                this.expenseReport.miscReportItems.push({
                    amount: null,
                    attachments: [
                    ],
                    itemDate: "",
                    miscReportItemTypeComment: "",
                    reason: "",
                    vendor: "",
                    miscReportItemTypeId: null,
                    projectAmountAllocations: [
                        {
                            projectId: null,
                            allocationValue: null
                        }
                    ]
                })
            },
            onAddprojectAmountAllocation(item) {
                item.projectAmountAllocations.push({
                    projectId: null,
                    allocationValue: null
                })
            },
            async getProjects() {
                try {
                    const data = await ProjectService.getUserProjects(this.submission ? this.submission.createdByUserId : null);
                    data.forEach(d => d.projectName = `${d.projectNumber} - ${d.projectName}`);
                    this.projects = data.filter(project => !project.archived);
                    // get projects saved in expense but not in user project list
                    let setA = this.projects.map(item => item.id);
                    console.log(this.expenseReport.miscReportItems)
                    let setB = this.expenseReport.miscReportItems
                                .map(item => item.projectAmountAllocations
                                    .map(item => item.projectId));
                    setB = [...new Set(setB.flat())];
                    const result = setB.filter(item => !setA.includes(item));
                    const results = await Promise.all(
                        result.map(async (projectId) => {
                            const expenseProject = await ProjectService.getProjectModel(projectId);
                            expenseProject.projectName = `${expenseProject.projectNumber} - ${expenseProject.projectName}`;
                            return expenseProject
                        })
                    )

                    // add the saved projects to the dropdown list
                    this.projects = this.projects.concat(results);
                } catch {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        text: error
                    });
                    this.errored = true
                }
            },
            async onSave() {
                this.loading = true;
                //Backend support multiple projects per expense report item. Only wiring up one at UI right now.
                //this.expenseReport.miscReportItems.forEach(mRI => mRI.projectAmountAllocations[0].allocationValue = mRI.amount);
                try {
                    let response = await MiscExpenseReportService.save(this.expenseReport);
                    this.expenseReport = response;
                    this.expenseReportID = response.expenseReportId;

                    this.expenseReportStatus = await TripProfileService.getExpenseReportStatus(response.expenseReportId);
                    this.expenseReportStatusTypeId = this.expenseReportStatus.expenseReportStatusTypeId;
                    this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Misc report saved successfully" });
                    this.$router.push({ path: "/misc-expense-report/" + response.expenseReportId });
                } catch (e) {
                    let guiError = e;
                    if (e.data) { guiError = e.data.join("<br>") }
                    this.$notify({ group: 'errors', type: 'error', title: 'Error', text: guiError });
                }
                finally {
                    this.$data.hash = JSON.stringify(this.expenseReport);
                    this.loading = false;
                    this.show_save_modal = false;
                }
            },
            async onSubmit(skipDateCheck) {
                this.loading = true;
                this.hideConfirmModal()

                // check for null projectId
                this.expenseReport.miscReportItems.forEach((item) => {
                    item.projectAmountAllocations.forEach((p) => {
                        if (p.projectId == null) {
                            this.$notify({
                                group: 'errors',
                                type: 'error',
                                title: 'Error',
                                text: 'The ProjectId field is required for submission'
                            });
                            this.errored = true
                        }
                    })
                })

                if (this.errored) {
                    this.loading = false;
                    this.errored = false;
                    return;
                }

                try {
                    let res = await MiscExpenseReportService.save(this.expenseReport);
                    this.expenseReport = res;
                    this.expenseReportID = res.expenseReportId;


                    if (!skipDateCheck && this.expenseReport.hasItemDateOutsideOneOrMoreProjectDates) {
                        this.$bvModal.show('confirm-submit-modal');
                        return;
                    }

                    let submitRequest = { ...this.submitModel }
                    submitRequest.expenseReportId = this.expenseReportID;
                    let response = await MiscExpenseReportService.submit(submitRequest);

                    this.expenseReportStatus = await TripProfileService.getExpenseReportStatus(this.expenseReportID);
                    this.expenseReportStatusTypeId = this.expenseReportStatus.expenseReportStatusTypeId;
                    this.show_modal = true
                } catch (e) {
                    let guiError = e;
                    if (e.data) {
                        guiError = e.data.join("<br>")
                    }
                    this.$notify({ group: 'errors', type: 'error', title: 'Error', text: guiError });
                }
                finally { this.loading = false }
            },
            hideConfirmModal() {
                this.$bvModal.hide('confirm-submit-modal');
            },
            openPrintView() {
                this.$router.push({ name: 'misc-expense-report-print', params: { erid: this.expenseReportID } });
            }
        },
        //auto save when navigating away from section
        async beforeRouteLeave(to, from, next) {

            if (this.$data.hash !== this.hashData) {
                this.show_save_modal = true;
            }
            else {
                console.log("Data has not changed");
                next();
            }       
        }
    }

</script>

